import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from './Constants';
import RequestHelper from './RequestHelper';
export default {
  /**
   * Helper Method to send server request to get SSO links
   * @async
   * @public
   * @returns {Object} SSO links object server returns
   */
  getSSOLinks: function () {
    var _getSSOLinks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var callResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_SSO_LINKS
              });

            case 3:
              callResponse = _context.sent;

              if (callResponse) {
                _context.next = 8;
                break;
              }

              throw Error("[Get-SSO-Links-response] undefined");

            case 8:
              if (!(callResponse.success === false)) {
                _context.next = 10;
                break;
              }

              throw Error("[Get-SSO-Links-response] ".concat(callResponse.error));

            case 10:
              return _context.abrupt("return", callResponse);

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              throw _context.t0;

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }));

    function getSSOLinks() {
      return _getSSOLinks.apply(this, arguments);
    }

    return getSSOLinks;
  }()
};